import { render, staticRenderFns } from "./HotelOrderIFlag.vue?vue&type=template&id=d6b60850&scoped=true"
import script from "./HotelOrderIFlag.vue?vue&type=script&lang=js"
export * from "./HotelOrderIFlag.vue?vue&type=script&lang=js"
import style0 from "./HotelOrderIFlag.vue?vue&type=style&index=0&id=d6b60850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b60850",
  null
  
)

export default component.exports